import { Box } from '@factorialco/deprecated-design-system'
import { PlannedBreakFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import BreakInformation from 'modules/time_planning/components/Breaks/BreakInformation'

interface Props {
  plannedBreaks: PlannedBreakFragment[]
}

const DayConfigRowBreaks = ({ plannedBreaks }: Props) => {
  return (
    <>
      {plannedBreaks.map((plannedBreak) => (
        <Box key={plannedBreak.id} flexDirection="row" alignItems="center">
          <BreakInformation plannedBreak={plannedBreak} />
        </Box>
      ))}
    </>
  )
}

export default observer(DayConfigRowBreaks)
